module.exports = __webpack_public_path__ + "media/images/subject_img/AERONAUTICAL ENGINEERING-9a0240ba385169c21ecc12eb991fae06.jpg";